import {
    getLeadTimes,
    downloadLeadTimes as downloadLeadTimesApi,
    downloadLeadTimesPerProductGroup as downloadLeadTimesPerProductGroupApi,
} from '../api/ProductLeadTimeApi';
import { IAlertModel } from '../../models/LeadTimes';
import { getProductsWithSchedules, deleteScheduleWithId, exportScheduleWithId } from "../api/ProductsApi";
import { productsSlice, callTypes } from "./ProductsSlice";
import moment from "moment";

const { actions } = productsSlice;
const errorTitle = 'Error while calling API';

const fetchProductsWithSchedules = (productGroupName: string, plant: string) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(actions.startCall({ callType: callTypes.list }));
        return getProductsWithSchedules(productGroupName, plant)
            .then(response => {

                const { totalCount, entities, schedules } = response;
                dispatch(actions.productsFetched({ totalCount, entities, schedules }));
            })
            .catch(error => {
                error.clientMessage = "Can't find products";
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            });
    };

const fetchProductGroupLeadtimes = (plant: string) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(actions.startCall({ callType: callTypes.list }));
        return getLeadTimes(plant)
            .then(response => {
                let { leadTimesPerGroup } = response;
                leadTimesPerGroup = leadTimesPerGroup
                    .filter(group => group.leadTimes?.length)
                    .sort((a, b) => a.name.localeCompare(b.name))
                dispatch(actions.productGroupLeadTimesFetched({ leadTimesPerGroup }));
            })
            .catch(error => {
                error.clientMessage = "Can't find products";
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            });
    };

const deleteSchedule = (plantCode: string, productGroup: string, scheduleId: string) =>
    (dispatch: any) => {
        dispatch(actions.startCall({ callType: callTypes.action }));
        return deleteScheduleWithId(plantCode, productGroup, scheduleId)
            .then(deleteScheduleResult => {
                dispatch(actions.scheduleDeleted({ scheduleId: scheduleId, deleteScheduleResult: deleteScheduleResult }));
            })
            .catch(error => {
                error.clientMessage = `Cannot delete schedule with ID ${scheduleId}`;
                dispatch(actions.catchError({ error, callType: callTypes.action }));
            });
    };

const exportSchedule = (plantCode: string, productGroup: string, scheduleId: string, scheduleName: string) =>
    (dispatch: any) => {
        dispatch(actions.startCall({ callType: callTypes.action }));
        return exportScheduleWithId(plantCode, productGroup, scheduleId)
            .then(exportScheduleResult => {
                dispatch(actions.scheduleExported({ scheduleId: scheduleId, exportScheduleResult: exportScheduleResult }));

                const uniqueUrl = `leadtimes-${plantCode}-${productGroup}-${scheduleName}`;
                const url = window.URL.createObjectURL(new Blob([exportScheduleResult]));
                const link = document.createElement('a');
                link.href = url;
                const dateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
                link.download = `${uniqueUrl}-${dateTime}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                error.clientMessage = `Cannot export schedule with ID ${scheduleId}`;
                dispatch(actions.catchError({ error, callType: callTypes.action }));
            });
    };

    const deleteScheduleClosed = () =>
    (dispatch: any) => {
        dispatch(actions.deleteScheduleClosed());
    };

export const downloadLeadTimes =
  (plantCode: string) => async (dispatch: (args: any) => void) => {
    dispatch(actions.startCall({ callType: callTypes.download }));
    try {
      const leadTimes = await downloadLeadTimesApi(plantCode);
      dispatch(actions.leadTimesDownloaded());
      const uniqueUrl = `leadtimes-${plantCode}`;

      const url = window.URL.createObjectURL(new Blob([leadTimes]));
      const link = document.createElement('a');
      link.href = url;
      const dateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
      link.download = `${uniqueUrl}-${dateTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const error = {
        title: errorTitle,
        message: "Can't download lead times",
        variant: 'danger'
      } as IAlertModel;
      console.error(err);
      dispatch(actions.catchError({ error, callType: callTypes.download }));
    }
  };

export const downloadLeadTimesPerProductGroup =
  (plantCode: string, productGroupName: string) => async (dispatch: (args: any) => void) => {
    dispatch(actions.startCall({ callType: callTypes.download }));
    try {
      const leadTimes = await downloadLeadTimesPerProductGroupApi(plantCode, productGroupName);
      dispatch(actions.leadTimesDownloaded());
      const uniqueUrl = `leadtimes-${plantCode}-${productGroupName}`;

      const url = window.URL.createObjectURL(new Blob([leadTimes]));
      const link = document.createElement('a');
      link.href = url;
      const dateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
      link.download = `${uniqueUrl}-${dateTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const error = {
        title: errorTitle,
        message: "Can't download lead times per group",
        variant: 'danger'
      } as IAlertModel;
      console.error(err);
      dispatch(actions.catchError({ error, callType: callTypes.download }));
    }
  };

export {
    fetchProductsWithSchedules,
    fetchProductGroupLeadtimes,
    deleteSchedule,
    deleteScheduleClosed,
    exportSchedule
};